import { MeasurementResponse, ProductResponse } from "./product.model";
import { UserResponse } from "./user.model";
import { WarehouseResponse } from "./warehouse.model";

export class ExistenceCountResponse {
	id: number;
	warehouse: WarehouseResponse;
	product: ProductResponse;
	user: UserResponse;
	inventory: InventoryCountResponse;
	physicalStock: number;
	systemStock: number;
	comment: string;
	counted: any;
}

export class InventoryCountResponse {
	id: number;
	closed: boolean;
	user: UserResponse;
	created: any;
	closedDate: any;
}

export class InventoryCountTodayResponse {
	list: DayExistenceCountResponse[];
	counted: boolean;
}

export class DayExistenceCountResponse {
	physicalStock: number;
	id: number;
	email: string;
	idUser: number;
	idWarehouse: number;
	nameWarehouse: string;
	comment: string;
	inventoryId: number;
	inventoryCreated: any;
	counted: any;
	nameProduct: string;
	idProduct: number;
	codeProduct: any;
	barCode: string;
}

export class ExistenceCountRequest {
	id: number;
	physicalStock: number;
	comment: string;
}

export class HistoryInventoryAllWarehousesResponse {
	existences: HistoryExistenceAllWarehousesResponse[];
	list: WarehouseMissingDaysResponse[];
	missing: number;
}

export class WarehouseMissingDaysResponse {
	missingDays: number;
	warehouse: WarehouseResponse;
}

export class HistoryExistenceAllWarehousesResponse {
	product: ProductResponse;
	physicalStock: number;
	systemStock: number;
	difference: number;
	surplus: boolean;
	comment: string;
	date: number;
	user: UserResponse;
}

export class InventoryAuditRequest {
	warehouse: number;
	auditor: number;
	existences: ExistenceAuditRequest[];
}

export class ExistenceAuditRequest {
	product: number;
	physicalStock: number;
}

export class MakeInventoryResponse {
	providerInvoice: any;
	clientInvoice: any;
	inventoryAudit: InventoryAuditModel;
	listExistences: ExistenceAuditResponse[];
}

export class InventoryAuditModel {
	auditor: number;
	warehouse: number;
	manager: number;
	audited: number;
	link: string;
}

export class ExistenceAuditResponse {
	product: number;
	physicalStock: number;
	systemStock: number;
	alreadyCounted: boolean;
	difference: number;
	sale: boolean;
	cost: number;
	alreadySaved: boolean;
	productData: ProductResponse;
}

export class RealizationInventoryPdfResponse {
    warehouseName: string;
    date: any;
	userName: string;
	products: ProductInventoryPDF[];
}

export class ProductInventoryPDF {
	idProduct: number;
	prodcutName: string;
	quantity: number;
}

export interface StatusExistenceDetailResponse {
	percentage: number;
	quantity: number;
	belongsToType: number;
	belongsTo: string;
}

export interface StatusWarehouseExistenceResponse {
	warehouse: WarehouseResponse;
	productData: ProductResponse;
	measurement: MeasurementResponse;
	excessQuantity: number;
	emptyQuantity: number;
	percentageInUsed: number;
	quantityInUsed: number;
	details: StatusExistenceDetailResponse[];
}

export interface StatusWarehouseAllExistenceResponse {
	totalQuantity: number;
	details: StatusWarehouseAllExistenceDetailResponse[];
}

export interface StatusWarehouseAllExistenceDetailResponse {
	totalQuantityWarehouse: number;
	percentageWarehouse: number;
	colorHex: string;
	warehouse: WarehouseResponse;
	details: StatusAllExistenceDetailResponse[];
}
export interface StatusAllExistenceDetailResponse {
	warehouse: WarehouseResponse;
	product: ProductResponse;
	quantity: number;
	percentage: number;
}